export const ENQUIRY_LOGO_SRC = "/img/RajNeethi Logo 5 1.svg";

export const ENQUIRY_RESUME_BUCKET = "urn-assets";
export const ENQUIRY_RESUME_BASE_URL = `https://${ENQUIRY_RESUME_BUCKET}.s3.ap-south-1.amazonaws.com/`;
export const ENQUIRY_RESUME_DOWNLOAD_ENDPOINT = "rn/downloadrncontactresume";
export const ENQUIRY_HR_UPDATE_ENDPOINT = "rn/update-rncontact";
export const DEFAULT_ENQUIRY_HR_STATUS = "new";

export const ENQUIRY_HR_STATUS_OPTIONS = [
    { value: "new", label: "New" },
    { value: "reviewing", label: "Reviewing" },
    { value: "shortlisted", label: "Shortlisted" },
    { value: "interview", label: "Interview" },
    { value: "rejected", label: "Rejected" },
    { value: "hired", label: "Hired" },
] as const;

export const ENQUIRY_FORM_TYPE_LABELS: Record<string, string> = {
    services: "Services",
    careers: "Careers",
    leads: "Leads",
};

export const ENQUIRY_ROLE_LABELS: Record<string, string> = {
    student: "Student",
    working_professional: "Working Professional",
};

export const ENQUIRY_FORM_TYPE_BADGES: Record<string, string> = {
    Services: "bg-sky-100 text-sky-700 ring-1 ring-sky-200",
    Careers: "bg-violet-100 text-violet-700 ring-1 ring-violet-200",
    Leads: "bg-amber-100 text-amber-700 ring-1 ring-amber-200",
};

export const ENQUIRY_PAGE_CLASS = "min-h-screen bg-gradient-to-b from-violet-50 via-white to-slate-50";
export const ENQUIRY_CONTAINER_CLASS = "w-full px-4 pb-10 pt-6 md:px-6 lg:px-8";

export const ENQUIRY_DATE_DISPLAY_FORMAT = "DD MMM YYYY, hh:mm A";

export const ENQUIRY_TIMESTAMP_FIELD_KEYS = ["timestamp", "date", "created_at", "ts", "created"];

export const ENQUIRY_DATE_RANGE_PRESETS = [
    { value: "all" as const, label: "All time" },
    { value: "today" as const, label: "Today" },
    { value: "last7" as const, label: "Last 7 days" },
    { value: "last30" as const, label: "Last 30 days" },
    { value: "custom" as const, label: "Custom" },
];

export const ENQUIRY_PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
export const DEFAULT_ENQUIRY_PAGE_SIZE = 10;

export const ENQUIRY_COPYABLE_FORM_TYPES = ["services", "careers", "leads"] as const;

export type EnquiryCopyFormType = (typeof ENQUIRY_COPYABLE_FORM_TYPES)[number];

export type EnquiryCopyFieldKey =
    | "name"
    | "phone"
    | "email"
    | "category"
    | "address"
    | "message"
    | "role"
    | "experience"
    | "linkedin"
    | "resume";

export const ENQUIRY_COPY_FIELD_LABELS: Record<EnquiryCopyFieldKey, string> = {
    name: "Name",
    phone: "Phone",
    email: "Email",
    category: "Category",
    address: "Address",
    message: "Message",
    role: "Current Role",
    experience: "Experience",
    linkedin: "LinkedIn",
    resume: "Resume",
};

export const ENQUIRY_COPY_FIELDS_BY_FORM_TYPE: Record<EnquiryCopyFormType, EnquiryCopyFieldKey[]> = {
    leads: ["name", "phone", "email", "category"],
    services: ["name", "phone", "email", "address", "message"],
    careers: ["name", "phone", "email", "role", "experience", "linkedin", "message"],
};
